/* ============================================================
   สิทธิ์ของผู้ใช้ที่ login อยู่ — โหลดครั้งเดียวตอนเข้าระบบ
   ใช้ผ่าน usePermission() เพื่อซ่อนเมนู / ปิดปุ่มตามตำแหน่ง

     const { can, canView, isAdmin } = usePermission();
     <Button disabled={!can("erp_job_order", "add")}>เพิ่ม</Button>
============================================================ */
import React, { createContext, useContext, useEffect, useState } from "react";
import PermissionService from "../../service/Permission.service";

const CACHE_KEY = "nsf_permission";
const permissionService = PermissionService();

const PermissionContext = createContext({
  loading: true,
  isAdmin: false,
  role: "",
  roleName: "",
  permission: {},
  can: () => false,
  canView: () => false,
  reload: () => {},
});

export const PermissionProvider = ({ children }) => {
  const [state, setState] = useState(() => {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? { ...JSON.parse(raw), loading: false } : { loading: true, permission: {} };
    } catch (e) {
      return { loading: true, permission: {} };
    }
  });

  const load = () => {
    permissionService
      .me()
      .then((res) => {
        const d = res.data?.data || {};
        const next = {
          loading: false,
          isAdmin: !!d.is_admin,
          role: d.role,
          roleName: d.role_name,
          permission: d.permission || {},
        };
        setState(next);
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify(next));
        } catch (e) {}
      })
      .catch(() => setState((s) => ({ ...s, loading: false })));
  };

  useEffect(() => {
    load();
  }, []);

  const can = (menuKey, action = "view") => {
    if (state.isAdmin) return true;
    return !!state.permission?.[menuKey]?.[action];
  };

  const value = {
    ...state,
    can,
    canView: (menuKey) => can(menuKey, "view"),
    reload: load,
  };

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
};

export const usePermission = () => useContext(PermissionContext);

/* เรียกตอน logout เพื่อไม่ให้สิทธิ์ของคนก่อนหน้าค้างอยู่ */
export const clearPermissionCache = () => {
  try {
    sessionStorage.removeItem(CACHE_KEY);
  } catch (e) {}
};

export default PermissionContext;
